import { render } from "./security.vue?vue&type=template&id=57032f8d&scoped=true&ts=true"
import script from "./security.vue?vue&type=script&lang=ts"
export * from "./security.vue?vue&type=script&lang=ts"

import "./security.vue?vue&type=style&index=0&id=57032f8d&lang=less&scoped=true"

import exportComponent from "D:\\Projects\\aba\\aba-cabinet-front\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-57032f8d"]])

export default __exports__